<div class="page">
  <div class="title-btn-container">
    <div class="title">{{ 'store.redemptions.title' | translate }}</div>
    <div class="btns-container">
      <button (click)="scanRedeem()">
        <img src="assets/images/scan-btn.png" alt="">
        {{ 'store.redemptions.redeemVoucher' | translate }}
      </button>
    </div>

  </div>

  <div class="redemptions-filters-container">
    <div class="inputs-container">
      <app-date-picker [from]="params.from" [to]="params['to']" (change)="getpickerValues($event)"></app-date-picker>
      <div class="search-container">
        <img src="assets/images/search.svg">
        <input
          [(ngModel)]="params.search"
          (keyup.enter)="doSearchByEnter($event);"
          (keyup)="doSearchByKeyUp($event);"
          [placeholder]="'store.redemptions.searchPlaceholder' | translate" type="text">
      </div>
<!--      <app-select [selectedItem]="params.status" [options]="statusList"-->
<!--                  (changeSelect)="changeFilter($event)"></app-select>-->
    </div>
    <div class="totals-container">
      <div class="totals-stats">
        <div class="value">{{stateCount}}</div>
        <div class="label">{{ 'store.redemptions.title' | translate }}</div>
      </div>
      <div class="totals-stats">
        <div  class="value"><span class="ltr-text">{{stateTotal | currency: stateCurrency: 'code'}}</span></div>
        <div class="label">{{ 'store.redemptions.total' | translate }}</div>
      </div>
    </div>

  </div>
  <div class="mobile-only mobile-table" *ngIf="dataList?.length">
    <div class="mobile-table__card" *ngFor="let item of dataList; let i = index">
      <div class="mobile-table__header">
        <div>
          <div class="mobile-table__title">{{item.title}}</div>
          <div  class="mobile-table__meta"><span class="ltr-text">{{item.redeemedOn | date: 'hh:mm, d MMMM y'}}</span></div>
        </div>
        <div class="mobile-table__actions">
          <button
            class="mobile-table__action-btn"
            [placement]="'bottom'"
            [outsideClick]="true"
            [popover]="popTemplateMobile"
            [attr.aria-label]="'common.actions' | translate"
          >
            <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
          </button>
          <ng-template #popTemplateMobile>
            <div class="mobile-table__menu-item" (click)="goToDetails(item.id)">{{ 'common.viewDetails' | translate }}</div>
          </ng-template>
        </div>
      </div>
      <div class="mobile-table__rows">
        <div class="mobile-table__row">
          <div class="mobile-table__label">{{ 'store.orders.table.voucherCode' | translate }}</div>
          <div class="mobile-table__value">
            <span *ngIf="item.voucherType !== 'ONE_PAY_VOUCHER'">{{item.code}}</span>
            <span *ngIf="item.voucherType === 'ONE_PAY_VOUCHER'"> -- </span>
          </div>
        </div>
        <div class="mobile-table__row">
          <div class="mobile-table__label">{{ 'store.redemptions.table.redeemedBy' | translate }}</div>
          <div class="mobile-table__value">{{item?.redeemedByUserName}}</div>
        </div>
        <div class="mobile-table__row">
          <div class="mobile-table__label">{{ 'store.orders.table.voucherValue' | translate }}</div>
          <div class="mobile-table__value">
            <span *ngIf="item.voucherType !== 'ONE_PAY_VOUCHER'">{{item.voucherValue}}</span>
            <span *ngIf="item.voucherType === 'ONE_PAY_VOUCHER'"> -- </span>
          </div>
        </div>
        <div class="mobile-table__row">
          <div class="mobile-table__label">{{ 'store.orders.table.price' | translate }}</div>
          <div class="mobile-table__value">
            <span *ngIf="item.voucherType !== 'ONE_PAY_VOUCHER'">{{item.price}}</span>
            <span *ngIf="item.voucherType === 'ONE_PAY_VOUCHER'"> -- </span>
          </div>
        </div>
        <div class="mobile-table__row">
          <div class="mobile-table__label">{{ 'common.fee' | translate }}</div>
          <div class="mobile-table__value">{{item.fee?.value}}</div>
        </div>
        <div class="mobile-table__row">
          <div class="mobile-table__label">{{ 'common.total' | translate }}</div>
          <div class="mobile-table__value">
            <!-- A store bonus voucher paid the store when it was bought; a use moves no money. -->
            <span *ngIf="item.fundingModel === 'STORE_PREPAID'; else mobileTotal">{{ 'store.redemptions.paidAtPurchase' | translate }}</span>
            <ng-template #mobileTotal>{{item.total}}</ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="empty-list mobile-only" *ngIf="!dataList?.length">{{ 'store.redemptions.empty' | translate }}</div>
  <div class="table-wrapper desktop-only">
    <table class="table AgentsTable">
      <thead>
      <tr>
        <th>{{ 'common.date' | translate }}</th>
        <th>{{ 'store.orders.table.voucherName' | translate }}</th>
        <th>{{ 'store.orders.table.voucherCode' | translate }}</th>
        <th>{{ 'store.redemptions.table.redeemedBy' | translate }}</th>
        <th>{{ 'store.orders.table.voucherValue' | translate }}</th>
        <th>{{ 'store.orders.table.price' | translate }}</th>
        <th>{{ 'common.fee' | translate }}</th>
        <th>{{ 'common.total' | translate }}</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let item of dataList; let i = index">
        <td ><span class="ltr-text">{{item.redeemedOn | date: 'hh:mm, d MMMM y'}}</span></td>
        <td>{{item.title}}</td>
        <td>
          <span *ngIf="item.voucherType !== 'ONE_PAY_VOUCHER'">{{item.code}}</span>
          <span *ngIf="item.voucherType === 'ONE_PAY_VOUCHER'"> -- </span>
        </td>
        <td>{{item?.redeemedByUserName}}</td>
        <td>
          <span *ngIf="item.voucherType !== 'ONE_PAY_VOUCHER'">{{item.voucherValue}}</span>
          <span *ngIf="item.voucherType === 'ONE_PAY_VOUCHER'"> -- </span>
        </td>
        <td>
          <span *ngIf="item.voucherType !== 'ONE_PAY_VOUCHER'">{{item.price}}</span>
          <span *ngIf="item.voucherType === 'ONE_PAY_VOUCHER'"> -- </span>
        </td>
        <td>{{item.fee?.value}}</td>
        <td>
          <span *ngIf="item.fundingModel === 'STORE_PREPAID'; else rowTotal">{{ 'store.redemptions.paidAtPurchase' | translate }}</span>
          <ng-template #rowTotal>{{item.total}}</ng-template>
        </td>

        <td class="dots-container">
          <button
            [placement]="'left'"
            [outsideClick]="true"
            [popover]="popTemplate"
          >
            <i
              class="fa fa-ellipsis-h" aria-hidden="true"></i>
          </button>

          <ng-template #popTemplate>
            <div class="mobile-table__menu-item" (click)="goToDetails(item.id)">            {{ 'common.viewDetails' | translate }}
            </div>
          </ng-template>
        </td>
      </tr>
      </tbody>

    </table>
    <div class="empty-list" *ngIf="!dataList?.length">{{ 'store.redemptions.empty' | translate }}</div>

  </div>
  <div class="table-footer">
    <app-pagination [totalPages]="totalPages" [currentPage]="params?.page" (backClicked)="backClick($event)"
                    (nextClicked)="nextClick($event)"></app-pagination>
    <app-export-csv [disabled]="!dataList?.length" path="web/redemptions/csv" [params]="params"></app-export-csv>
  </div>
  <ngx-spinner color="rgba(30, 205, 100, 1)" type="ball-scale-multiple"></ngx-spinner>
</div>
<app-redeem-modal
  #redeemModal
  [currencyCode]="stateCurrency || 'ILS'"
  (onRedeemAction)="onRedeem($event)"
  (onSuccess)="getItems()">
</app-redeem-modal>
